// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AppToken  {
    _originalTypeClassName = "Loom.BO.AppToken";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AppToken.translate = translateService;
}
this.Username = null;
this.Expiration = null;
this.Token = null;
this.AppTokenKey = null;
this._key = this.AppTokenKey = 0; 
}

static translate: TranslateService;
_key: any;
Username:any;
Expiration:any;
Token:any;
private _AppTokenKey:any;
get AppTokenKey(): any {
    return this._AppTokenKey;
  }
set AppTokenKey(value: any) {
    this._AppTokenKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AppTokenKey == null || $this.AppTokenKey == 0;
            }


}